import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconListCheck12(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={12}
            height={12}
            className={customClassName}
            name="IconListCheck12"
            aria-hidden="true"
            {...props}
        >
            <g fill="none">
                <g clipPath="url(#ListCheck12)">
                    <path
                        fill="currentColor"
                        fillRule="evenodd"
                        d="M5.254 1.046a.5.5 0 0 1 0 .708l-2.8 2.8-.354.353-.354-.353-1.4-1.4a.5.5 0 0 1 .707-.707L2.1 3.493l2.447-2.447a.5.5 0 0 1 .707 0M3.5 7h-2a.5.5 0 0 0-.5.5v2a.5.5 0 0 0 .5.5h2a.5.5 0 0 0 .5-.5v-2a.5.5 0 0 0-.5-.5m-2-1A1.5 1.5 0 0 0 0 7.5v2A1.5 1.5 0 0 0 1.5 11h2A1.5 1.5 0 0 0 5 9.5v-2A1.5 1.5 0 0 0 3.5 6zm10.53-4.5a.5.5 0 0 1-.5.5H7.485a.5.5 0 1 1 0-1h4.045a.5.5 0 0 1 .5.5m-.934 3a.5.5 0 0 1-.5.5H7.485a.5.5 0 0 1 0-1h3.111a.5.5 0 0 1 .5.5M11.53 8a.5.5 0 0 0 0-1H7.485a.5.5 0 0 0 0 1zm-.434 2.5a.5.5 0 0 1-.5.5H7.485a.5.5 0 0 1 0-1h3.111a.5.5 0 0 1 .5.5"
                        clipRule="evenodd"
                    />
                </g>
                <defs>
                    <clipPath id="ListCheck12">
                        <path fill="#fff" d="M0 0h12v12H0z" />
                    </clipPath>
                </defs>
            </g>
        </svg>
    );
}
export default memo(IconListCheck12);
